import { SEARCH_DETAILS_PATH } from '@/consts/paths';
import type { SearchCategoriesType } from '@/consts/search-const';
import { FILTER_DIRECTORY_QUERY_KEY, FILTER_PARTNERS_QUERY_KEY } from '../../consts/search-const';

export const goToSearchDetails = ({
  category,
  searchQuery,
  directory,
  partners,
}: {
  category: SearchCategoriesType;
  searchQuery?: string | null;
  directory?: string[] | null;
  partners?: string[] | null;
}) => {
  return `${SEARCH_DETAILS_PATH}?page=${category}${searchQuery ? `&query=${searchQuery}` : ''}${directory?.length ? `&${FILTER_DIRECTORY_QUERY_KEY}=${directory.join(`&${FILTER_DIRECTORY_QUERY_KEY}=`)}` : ''}${partners?.length ? `&${FILTER_PARTNERS_QUERY_KEY}=${partners.join(`&${FILTER_PARTNERS_QUERY_KEY}=`)}` : ''}`;
};